import { ChangeDetectorRef, Component, Input, OnChanges, SimpleChanges, ViewChild } from '@angular/core';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { FileUploadStatus } from '../../models/fileUploadStatus.model';
import { TerminalStatus } from '../../models/datafox-device.model';
import { FileUploadDownloadStatus } from '../../models/fileUploadDownloadStatus.enum';

@Component({
    selector: 'upload-protocol-details',
    templateUrl: './upload-protocol-details.component.html',
    styleUrls: ['./protocol-modal-dialog.component.scss'],
    standalone: false
})
export class UploadProtocolDetailsComponent implements OnChanges {

  @Input() data: FileUploadStatus[];

  public uploadStatusFiltered: FileUploadStatus[];
  public displayedColumns = ['deviceType', 'serialNumber', 'deviceStatus', 'status', 'retryAttempts', 'lastUpdate', 'errorMessage'];
  public tabledata: MatTableDataSource<FileUploadStatus>;
  @ViewChild(MatSort, { static: false }) sort: MatSort;

  constructor(private cdr: ChangeDetectorRef) {

  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['data'] && this.data?.length) {
      this.uploadStatusFiltered = [...this.data];
      this.search();
    } else {
      this.data = null;
      this.uploadStatusFiltered = null;
    }
  }

  private initializeTable() {
    this.tabledata = new MatTableDataSource(this.uploadStatusFiltered);
    this.tabledata.sort = this.sort;
    this.tabledata.sortingDataAccessor = (item, property) => {
      switch (property) {
        case 'deviceType': return item.deviceType;
        case 'serialNumber': return item.serialNumber;
        case 'deviceStatus': return item.deviceStatus;
        case 'status': return item.status;
        case 'retryAttempts': return item.retryAttempts;
        case 'lastUpdate': return new Date(item.lastUpdated).getTime();
        default: return item[property];
      }
    }
  }

  // Search
  public searchTerm: string = "";

  search(): void {
    this.uploadStatusFiltered = this.data;
    let term = this.searchTerm.replace(/\s/g, "").toLowerCase();
    this.uploadStatusFiltered = this.data.filter(function (tag) {
      if (tag.deviceStatus == TerminalStatus.Offline
        && ('Offline').toLowerCase().indexOf(term) >= 0) {
        return true;
      }
      if (tag.deviceStatus == TerminalStatus.Online
        && ('Online').toLowerCase().indexOf(term) >= 0) {
        return true;
      }
      if (tag.deviceStatus == TerminalStatus.Wait
        && ('Warten').toLowerCase().indexOf(term) >= 0) {
        return true;
      }

      if (tag.status == FileUploadDownloadStatus.Cancelled
        && ('Abgebrochen').toLowerCase().indexOf(term) >= 0) {
        return true;
      }
      if (tag.status == FileUploadDownloadStatus.Downloading
        && ('Wird heruntergeladen').toLowerCase().indexOf(term) >= 0) {
        return true;
      }
      if (tag.status == FileUploadDownloadStatus.Failed
        && ('Fehlgeschlagen').toLowerCase().indexOf(term) >= 0) {
        return true;
      }
      if (tag.status == FileUploadDownloadStatus.Pending
        && ('Ausstehend').toLowerCase().indexOf(term) >= 0) {
        return true;
      }
      if (tag.status == FileUploadDownloadStatus.Success
        && ('Erfolgreich').toLowerCase().indexOf(term) >= 0) {
        return true;
      }

      return (tag.serialNumber?.toLowerCase().indexOf(term) >= 0)
        || (tag.deviceType?.toLowerCase().indexOf(term) >= 0)
        || (tag.errorMessage?.toLowerCase().indexOf(term) >= 0);
    });

    this.initializeTable();
  }

  public trackByIndex(i: number) {
    return i;
  }

}
